export default "__VITE_ASSET__ZQ9zLZGL__"